import React from 'react'

import PageRightRailColumn from '../../ui/layout/pageRightRail/PageRightRailColumn'
import { usePageRightRail } from '../../ui/layout/pageRightRail/PageRightRailProvider'
import InvoiceStackedList from '../stacked/InvoiceStackedList'
import Spinner from '../../ui/spinner'
import Button, { ButtonSize, ButtonVariant } from '../../ui/button'
import RecentInvoicesPanelTrigger from './RecentInvoicesPanelTrigger'
import { useRecentInvoicesRail } from './RecentInvoicesPanelProvider'

const RecentInvoicesPageRail: React.FC = () => {
  const { isOpen, close } = usePageRightRail()
  const {
    invoices,
    activeInvoiceId,
    isLoading,
    isLoadingMore,
    hasMore,
    onLoadMore,
  } = useRecentInvoicesRail()

  const bodyRef = React.useRef<HTMLDivElement>(null)
  const scrolledToActiveRef = React.useRef(false)

  React.useEffect(() => {
    if (!isOpen || !activeInvoiceId || isLoading || scrolledToActiveRef.current) return

    const activeEl = bodyRef.current?.querySelector('.invoice-stacked-card--active')
    if (activeEl) {
      activeEl.scrollIntoView({ block: 'nearest' })
      scrolledToActiveRef.current = true
    }
  }, [isOpen, activeInvoiceId, isLoading, invoices])

  React.useEffect(() => {
    if (!isOpen) {
      scrolledToActiveRef.current = false
    }
  }, [isOpen])

  const footer = hasMore && !isLoading ? (
    <Button
      variant={ButtonVariant.LIGHT}
      size={ButtonSize.SMALL}
      className='recent-invoices-panel__load-more'
      loading={isLoadingMore}
      loadingText='Loading'
      onClick={onLoadMore}
    >
      Load more
    </Button>
  ) : undefined

  return (
    <PageRightRailColumn
      isOpen={isOpen}
      onClose={close}
      header={<RecentInvoicesPanelTrigger />}
      panelId='recent-invoices-panel'
      panelAriaLabel='Recent invoices'
      footer={footer}
      bodyRef={bodyRef}
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <InvoiceStackedList invoices={invoices} activeInvoiceId={activeInvoiceId} />
      )}
    </PageRightRailColumn>
  )
}

export default RecentInvoicesPageRail
